import React, { useState } from 'react';
import cx from 'classnames';

import { LeftNavMenu, LeftNavMainContent } from './components';
import { WIDTHS, TOP_PADDING_MAP } from './constants';

import './left-nav-layout.css';

export function LeftNavLayout({
    accountDropdown,
    children,
    collapsedHeaderPadding,
    footer = null,
    header = null,
    headerPadding = 'sm',
    mainContentId,
    mainWidth,
    loading = false,
    logo,
    menuItems,
    topPadding,
}: LeftNavLayoutProps): JSX.Element {
    const [scrollState, setScrollState] = useState<ScrollState>('up');

    let headerTopPadding = TOP_PADDING_MAP[headerPadding];

    if (collapsedHeaderPadding && scrollState === 'down') {
        headerTopPadding = TOP_PADDING_MAP[collapsedHeaderPadding];
    }

    return (
        <>
            <LeftNavMenu
                accountDropdown={accountDropdown}
                logo={logo}
                menuItems={menuItems}
            />
            <div className="flex flex-col left-nav-layout h-full w-full bg-no-repeat bg-fixed absolute">
                {header !== null && (
                    <div
                        className={cx('header', header.wrapperClass)}
                        style={{
                            paddingLeft:
                                WIDTHS.LEFT_NAV + WIDTHS.MAIN_LEFT_MARGIN,
                            paddingTop: headerTopPadding,
                        }}
                    >
                        {header.content}
                    </div>
                )}
                <LeftNavMainContent
                    mainContentId={mainContentId}
                    mainWidth={mainWidth}
                    loading={loading}
                    collapsedHeaderPadding={collapsedHeaderPadding}
                    scrollState={scrollState}
                    setScrollState={setScrollState}
                    topPadding={topPadding}
                >
                    {children}
                </LeftNavMainContent>
                {footer !== null && (
                    <div
                        className={cx('footer', footer.wrapperClass)}
                        style={{
                            paddingLeft: WIDTHS.LEFT_NAV,
                        }}
                    >
                        {footer.content}
                    </div>
                )}
            </div>
        </>
    );
}
